var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    computed: __assign({}, mapState('info', {
        merchantBasicInfo: 'merchantBasicInfo',
        merchantBankInfoList: 'merchantBankInfoList',
        merchantOperationInfo: 'merchantOperationInfo',
    })),
    data: function () {
        return {
            isRealName: true,
            accountList: [
                {
                    span: 12,
                    title: '基础信息',
                    list: [],
                },
                {
                    span: 12,
                    title: '联系人信息',
                    list: [],
                },
                {
                    span: 24,
                    title: '结算信息',
                    list: [],
                },
                {
                    span: 12,
                    title: '企业实名信息',
                    list: [],
                },
                {
                    span: 12,
                    title: '法人信息',
                    list: [],
                },
            ],
            realName: {
                noRealName: {
                    url: require('../../assets/images/user/warning-icon.svg'),
                    status: 'ToRealName',
                    statusText: '您还未进行企业实名认证',
                    des: '为了您更好地体验控制台，我们建议您先进行企业实名',
                    buttonText: '去实名认证',
                },
                pending: {
                    url: require('../../assets/images/user/waiting-icon.svg'),
                    status: '',
                    statusText: '企业实名认证审核中…',
                    des: '我们将在3个工作日内完成审核，审核结果将通过短信发送给你',
                },
                error: {
                    url: require('../../assets/images/user/error-icon.svg'),
                    status: '',
                    statusText: '企业实名认证失败',
                    des: '企业实名认证失败',
                    buttonText: '修改信息',
                },
            },
            currentStatus: {
                url: require('../../assets/images/user/waiting-icon.svg'),
                status: '',
                statusText: '企业实名认证审核中…',
                des: '我们将在3个工作日内完成审核，审核结果将通过短信发送给你',
            },
        };
    },
    created: function () {
        this.update();
    },
    methods: {
        update: function () {
            var _a = this, merchantBasicInfo = _a.merchantBasicInfo, merchantBankInfoList = _a.merchantBankInfoList, merchantOperationInfo = _a.merchantOperationInfo;
            if (!merchantBasicInfo) {
                return;
            }
            var merchantBankInfo = merchantBankInfoList[0];
            var type = merchantBankInfo.type;
            var businessLicenseUrl = merchantOperationInfo.businessLicenseUrl;
            var bankAccountLicenseUrl = merchantOperationInfo.bankAccountLicenseUrl;
            var legalPersonIdentityType = merchantOperationInfo.legalPersonIdentityType;
            var legalPersonIdentityUrlFront = merchantOperationInfo.legalPersonIdentityUrlFront;
            var legalPersonIdentityUrlBack = merchantOperationInfo.legalPersonIdentityUrlBack;
            var legalPersonIdentityTypeChange = function (type) {
                var name = '';
                switch (type) {
                    case 1:
                        name = '身份证';
                        break;
                    case 2:
                        name = '护照';
                        break;
                    case 3:
                        name = '军官证';
                        break;
                    default:
                        name = '其他';
                }
                return name;
            };
            this.accountList[0].list = [
                {
                    key: '商户名称',
                    val: merchantBasicInfo.fullName,
                },
                {
                    key: '商户编号',
                    val: merchantBasicInfo.merchantId,
                },
            ];
            this.accountList[1].list = [
                {
                    key: '姓名',
                    val: merchantOperationInfo.legalPersonName,
                },
                {
                    key: '手机号',
                    val: merchantOperationInfo.legalPersonCellPhone,
                },
                {
                    key: '邮箱',
                    val: merchantOperationInfo.legalPersonEmail,
                },
            ];
            this.accountList[2].list = [
                {
                    key: '账户类型',
                    val: type === 0 ? '对公' : type === 1 ? '对私' : '',
                },
                {
                    key: '账户名称',
                    val: merchantBankInfo.name,
                },
                {
                    key: '银行账户号',
                    val: merchantBankInfo.accountNo,
                },
                {
                    key: '开户省',
                    val: merchantBankInfo.province,
                },
                {
                    key: '开户市',
                    val: merchantBankInfo.city,
                },
                {
                    key: '开户支行名称',
                    val: merchantBankInfo.branchBank,
                },
            ];
            this.accountList[3].list = [
                {
                    key: '统一社会信用代码',
                    val: merchantOperationInfo.socialCreditCode,
                },
                {
                    key: '营业执照注册号',
                    val: merchantOperationInfo.businessLicenseNo,
                },
                {
                    key: '银行开户许可证号',
                    val: merchantOperationInfo.bankAccountLicenseNo,
                },
                {
                    key: '营业执照影印件',
                    val: '',
                    imgList: [
                        {
                            url: businessLicenseUrl,
                            alt: '暂无图片',
                        },
                    ],
                },
                {
                    key: '银行开户许可证影印件',
                    val: '',
                    imgList: [
                        {
                            url: bankAccountLicenseUrl,
                            alt: '暂无图片',
                        },
                    ],
                },
            ];
            this.accountList[4].list = [
                {
                    key: '姓名',
                    val: merchantOperationInfo.legalPersonName,
                },
                {
                    key: '证件类型',
                    val: legalPersonIdentityTypeChange(legalPersonIdentityType),
                },
                {
                    key: '证件号码',
                    val: merchantOperationInfo.legalPersonIdentityCode,
                },
                {
                    key: '证件影印件',
                    val: '',
                    imgList: [
                        {
                            url: legalPersonIdentityUrlFront,
                            alt: '证件正面照',
                        },
                        {
                            url: legalPersonIdentityUrlBack,
                            alt: '证件背面照',
                        },
                    ],
                },
            ];
        },
    },
    watch: {
        merchantBasicInfo: {
            handler: function (val) {
                if (val) {
                    this.update();
                }
            },
            deep: true,
        },
    },
});
